export default "__VITE_ASSET__SZg_CL_D__"